import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { ModelWithForm, useValue, WhenLoaded, WhenModelValue } from '@morningtrain/react-resources'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import * as Displays from 'support/displays'
import ViewMessage from 'widgets/smartviews/hr/messages/ViewMessage'
import EditMessageForm from 'widgets/smartviews/hr/messages/EditMessageForm'
import ConfirmFormChanges from 'support/pipelines/ConfirmFormChanges'

export default function ViewMessageSmartview (props) {
  const modelId = useValue('id')
  const id = props.id || modelId

  return (
    <Translator namespace='smartviews.message'>
      <Smartview size='lg'>

        <ModelWithForm resourceName='messages.messages' id={id}>
          <ConfirmFormChanges />

          <WhenLoaded>

            <SmartviewHeader>
              <WhenModelValue name='id' negate>
                <Translation name='title' />
              </WhenModelValue>
              <WhenModelValue name='id'>
                <Displays.Text name='subject' />
              </WhenModelValue>
            </SmartviewHeader>

            <SmartviewContentSection>
              <WhenModelValue name='status' condition={2} negate>
                <EditMessageForm key={id} />
              </WhenModelValue>
              <WhenModelValue name='status' condition={2}>
                <ViewMessage />
              </WhenModelValue>

            </SmartviewContentSection>
          </WhenLoaded>

        </ModelWithForm>

      </Smartview>
    </Translator>
  )
}
